import React, { useState, useEffect ,useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button, Icon ,Grid, Container } from 'semantic-ui-react';
import { VscTriangleRight } from "react-icons/vsc";
import { VscTriangleDown } from "react-icons/vsc";
import Loader from "../../components/Loader";
import { fetchDataSetParameters ,getUserDataB2C} from '../../actions/dataConsoleAction';
import '../../styles/QnaSettingsHistory.css'; // Import the CSS file
import 'semantic-ui-css/semantic.min.css';
import { grey } from '@mui/material/colors';
import { fontSize } from '@mui/system';

const QnaSettingsHistory = ({ datasetId }) => {
  const dispatch = useDispatch();
  const parameters = useSelector((state) => state.parameters.parameters);
  const loading = useSelector((state) => state.parameters.loading);
  const error = useSelector((state) => state.parameters.error);
  const [expandedRows, setExpandedRows] = useState({});
  const [versionData, setversionData] = useState([]);
  const [uniqueUserIds, setUniqueUserIds] = useState([]);
  const isMounted=useRef(false);
  const userData=useSelector((state)=>state.getUser.response);
 
  useEffect(() => {
    if (parameters) {
      setversionData(parameters);
    }
    console.log('Version data',versionData);
  }, [parameters]);
 
  useEffect(() => {
    if ( !isMounted.current  && datasetId) {
      dispatch(fetchDataSetParameters(datasetId, true));
      isMounted.current = true;
    }
  }, [datasetId, dispatch]);

  useEffect(() => {
    if (versionData.length > 0) {
      const uniqueIds = [...new Set(versionData.map((item) => item.createdBy))];
      setUniqueUserIds(uniqueIds);
      console.log('unique ids', uniqueIds);
    }
  },[versionData]);

  useEffect(() => {
    if (uniqueUserIds.length > 0) {
      uniqueUserIds.forEach((userId) => {
        if (userId && (!userData || !userData[userId]))  {
          dispatch(getUserDataB2C(userId));
        }
      });
      console.log('User data', userData);
    }
  }, [uniqueUserIds]);

  const toggleRow = (id) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };
  const orderedKeys = [
    { displayName: 'QnA Prompt ', key: 'prompt' },
    { displayName: 'K Value ', key: 'kValue' },
    { displayName: 'Threshold Value ', key: 'thresholdValue' },
    { displayName: 'Temperature ', key: 'temperature' },
    { displayName: 'Maximum Output Tokens ', key: 'maxTokens' },
    { displayName: 'Top P Value ', key: 'topPValue' },
    { displayName: 'Model Name ', key: 'modelName' },
    { displayName: 'Enable Re-ranker ', key: 'enableReRanker' },
    { displayName: 'Show Images Option', key: 'showImagesOption'},
    { displayName: 'Show Source', key: 'showSource'},
    { displayName: 'Question Generator Prompt ', key: 'questionGeneratorPrompt' },
    { displayName: 'Clarify Prompt ', key: 'clarifyPrompt' },
    { displayName: 'Q&A Regenerate Prompt ', key: 'regeneratePrompt' },
    { displayName: 'Q&A Regenerate with Feedback Prompt ', key: 'regenerateWithFeedbackPrompt' },
    { displayName: 'Table Schema ', key: 'tableSchema' },
  ];

  if (loading) {
    return <Loader />;
  }

  return (
  <div className="main-container">
    <div className="responsive-grid">
    <Container>
        <Grid >
          <Grid.Row columns={3}>
            <Grid.Column  mobile={3} tablet={3} computer={3} className='grid-header'>Version</Grid.Column>
            <Grid.Column  mobile={7} tablet={4} computer={4} className='grid-header'>Modified By</Grid.Column>
            <Grid.Column  mobile={2} tablet={5} computer={5} className='grid-header'>Modified Date</Grid.Column>
          </Grid.Row>
        </Grid>
      <React.Fragment>
        {Array.isArray(versionData) && versionData.length >0 ? (
          versionData.map((row) => (
          <React.Fragment key={row._id}>
            <Grid>
              <Grid.Row columns={3} className={`grid-row grid-content ${versionData.indexOf(row) % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                <Grid.Column mobile={3} tablet={3} computer={3} onClick={() => toggleRow(row._id)} style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', alignItems: 'center' }} className='column-space'>
                  <Icon style={{ fontSize: '1.52rem', color: 'grey' }}>{expandedRows[row._id] ? <VscTriangleDown /> : <VscTriangleRight />}</Icon>
                  {row.version}
                </Grid.Column>
                <Grid.Column mobile={7} tablet={4} computer={4} className='column-space'>
                {userData[row.createdBy] ? userData[row.createdBy] : '-'}
                </Grid.Column>
                <Grid.Column mobile={2} tablet={5} computer={5} className='column-space'>
                {new Date(row.createdAt).toLocaleDateString('en-GB', {day: '2-digit',month: 'short',year: 'numeric',hour: '2-digit', minute: '2-digit'})}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {expandedRows[row._id] && (
              <Grid className='expanded-row'>
                 {orderedKeys.map(({ displayName, key }) => (
              <Grid.Row key={key} className='expanded-content-item'>
                <Grid.Column>
                  <strong>{displayName}:</strong> 
                  <span> </span>
                  { 
                    row[key] === undefined || row[key] === null || row[key] === '' 
                      ? 'Not Available' 
                      : typeof row[key] === 'boolean' 
                        ? (row[key] ? 'Yes' : 'No') 
                        : typeof row[key] === 'object' 
                          ? JSON.stringify(row[key]) 
                          : row[key]
                  }
                </Grid.Column>
              </Grid.Row>
            ))}
              </Grid>
            )}
          </React.Fragment>
        ))
      ):(
        <div className="emptyContainer">
            <img src="/images/empty-state.svg" alt="Empty State" />
            <p className="emptyMessage">
              <span className="titleMessage">No data available </span>
            </p>
        </div>
      )}
      </React.Fragment>
    </Container>
  </div>
  </div>
);
}
export default QnaSettingsHistory;